import { render } from "./AdminRole.vue?vue&type=template&id=b77c4126"
import script from "./AdminRole.vue?vue&type=script&lang=js"
export * from "./AdminRole.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__